import i18n from "../../i18n/index";
import ApiService from "../../services/ApiService";
import DayClosureService from "../../services/day-closure/DayClosureService";
export default {
  props: {
    returnsData: {
      type: Array,
      default: () => []
    },
    date: {
      type: Date,
      default: () => date
    }
  },
  data() {
    return {
      headers: [
        {
          text: i18n.t("headers.patient-document"),
          sortable: false,
          align: "left"
        },
        {
          text: i18n.t("headers.patient-name"),
          sortable: false,
          align: "left"
        },
        {
          text: i18n.t("headers.nro-order"),
          sortable: false,
          value: "number"
        },
        {
          text: i18n.t("headers.provider"),
          value: "providerId",
          sortable: false
        },
        {
          text: i18n.t("headers.total-documents"),
          value: "providerId",
          sortable: false
        },
        {
          text: i18n.t("headers.total-moderator-fee-with-weights"),
          value: "providerId",
          sortable: false
        }
        //{ text: i18n.t('headers.cancel'), sortable: false }
      ],
      itemsData: []
    };
  },
  watch: {
    returnsData() {
      this.itemsData = [];
      this.returnsData.forEach(items => {
        let item = {};
        item.orderNumber = items.orderNumber;
        item.providerName = items.providerName;
        item.documentCount = items.documentCount;
        item.scaleFeeTotal = Math.ceil(items.scaleFeeTotal);
        if (items.patients.length === 1) {
          items.patients.forEach(patients => {
            item.documento = patients.identification;
            item.nombre = patients.name;
          });
        } else {
          let patients = "",
            names = "";
          items.patients.forEach(p => {
            let patient = p.identification;
            let namePatient = p.name;
            patients = patients.concat(patient + " - ");
            names = names.concat(namePatient + " - ");
          });
          item.documento = patients.trimRight(" - ");
          item.nombre = names.trimRight(" - ");
        }
        this.itemsData.push(item);
      });
    }
  },
  methods: {
    cancel(code) {
      DayClosureService.cancelReturn(this.date, code)
        .then(response => {
          if (response.status === 201) {
            this.$emit("delete-order");
          }
          return response;
        })
        .catch(error => {
          return error;
        });
    }
  }
};
